import { buttonArrType } from "DataTypes/Modal";
import { FormDataType, FormObjType } from "DataTypes/Form";
import ControlledForm from "Components/ControlledForm";
import { TimeZoneArr } from "Constant/Arr";

export const TimeModalFormData: FormDataType[] = [
  ControlledForm.FormData.StartDateTime(),
  ControlledForm.FormData.EndDateTime(),
  ControlledForm.FormData.Reason(),
  ControlledForm.FormData.Duration(),
  ControlledForm.FormData.Notes(),
];

export const bpdataArr: FormDataType[] = [
  {
    id: "diastolic",
    label: "Diastolic",
    placeholder: " ",
    boxType: "input-box",
    boxSize: 4,
    validatetype: "name",
    required: true,
  },
  {
    id: "systolic",
    label: "Systolic",
    placeholder: " ",
    boxType: "input-box",
    boxSize: 4,
    validatetype: "name",
    required: true,
  },
];
export const hrdataArr: FormDataType[] = [
  {
    id: "low",
    label: "Low",
    placeholder: "",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    required: true,
  },
  {
    id: "high",
    label: "High",
    placeholder: " ",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    required: true,
  },
];
export const gludataArr: FormDataType[] = [
  {
    id: "low",
    label: "Low",
    placeholder: "",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    required: true,
  },
  {
    id: "high",
    label: "High",
    placeholder: " ",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    required: true,
  },
];
export const thrdataArr: FormDataType[] = [
  {
    id: "low",
    label: "Low",
    placeholder: "",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    required: true,
  },
  {
    id: "high",
    label: "High",
    placeholder: " ",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    required: true,
  },
];
export const pluoxdataArr: FormDataType[] = [
  {
    id: "oxsolu",
    label: "Oxygen Saturation % ",
    placeholder: " ",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    required: true,
  },
];

export const CommonButtonArray: (
  ConfirmHandler: () => void,
  CancelHandler: () => void,
  SaveLabel?: string,
  CancelLabel?: string,
  disableParameter?: boolean
) => buttonArrType[] = (
  ConfirmHandler,
  CancelHandler,
  SaveLabel,
  CancelLabel,
  disableParameter
) => {
  return [
    {
      id: "1",
      label: SaveLabel ? SaveLabel : "Save",
      clickHandler: ConfirmHandler,
      disable: disableParameter,
    },
    {
      id: "2",
      label: CancelLabel ? CancelLabel : "Cancel",
      clickHandler: CancelHandler,
      type: "border",
    },
  ];
};

export const DeleteButtonArray: (
  ConfirmHandler: () => void,
  CancelHandler: () => void
) => buttonArrType[] = (ConfirmHandler, CancelHandler) => {
  return [
    {
      id: "1",
      label: "Yes",
      clickHandler: ConfirmHandler,
    },
    {
      id: "2",
      label: "No",
      clickHandler: CancelHandler,
      type: "border",
    },
  ];
};

export const SingleBtnArray: (
  OkHandler: () => void,
  BtnLabel?: string
) => buttonArrType[] = (OkHandler, BtnLabel) => {
  return [
    {
      id: "1",
      label: BtnLabel ? BtnLabel : "Ok",
      clickHandler: OkHandler,
    },
  ];
};

export const patientName: FormObjType = {
  id: "patientName",
  label: "Patient Name",
  placeholder: "Patient's Name",
  boxType: "input",
  boxSize: 6,
  validatetype: "alphanumericPeriod",
  readOnly: true,
};
export const patientSearch: FormObjType = {
  id: "patient",
  label: "Patient",
  placeholder: "Select Patient",
  boxType: "single-select",
  boxSize: 6,
  validatetype: "dropdown",
  onChangeApiSearch: true,
  apiSearch: true,
  iconSearch: true,
  required: true,
};
export const appointmentTypeName: FormObjType = {
  id: "appointment-type",
  label: "Appointment Type",
  placeholder: "Select Appointment Type",
  boxType: "input",
  boxSize: 6,
  validatetype: "org-name",
  required: true,
};
export const appointmentType: FormObjType = {
  id: "appointment-type",
  label: "Appointment Type",
  placeholder: "Select Appointment Type",
  boxType: "single-select",
  boxSize: 6,
  validatetype: "dropdown",
  required: true,
};
export const deviceTypeName: FormObjType = {
  id: "device-type",
  label: "Device Type",
  placeholder: "Select Device Type",
  boxType: "empty",
  boxSize: 6,
  validatetype: "alphanumeric",
};
export const deviceType: FormObjType = {
  id: "device-type",
  label: "Device Type",
  placeholder: "Select Device Type",
  boxType: "single-select",
  boxSize: 6,
  validatetype: "dropdown",
  required: true,
};
export const orgName: FormObjType = {
  id: "practice",
  label: "Organization",
  placeholder: "Organization",
  boxType: "input",
  boxSize: 6,
  validatetype: "org-name",
  readOnly: true,
};
export const providerName: FormObjType = {
  id: "provider",
  label: "Provider",
  placeholder: "Provider's Name",
  boxType: "input",
  boxSize: 6,
  validatetype: "alphanumericPeriod",
  readOnly: true,
};
export const appointmentDateTime: FormObjType = {
  id: "appointment-date-time",
  label: "Appointment Date Time",
  placeholder: "Select Appointment Date Time",
  boxType: "date-time",
  boxSize: 6,
  validatetype: "date",
  required: true,
};
export const timezoneData: FormObjType = {
  id: "timezone",
  label: "Timezone",
  placeholder: "Select Timezone",
  boxType: "single-select",
  boxSize: 6,
  validatetype: "dropdown",
  required: true,
  dropArr: TimeZoneArr
};
export const appointmentNotes: FormObjType = {
  id: "notes",
  label: "Notes",
  placeholder: "Enter Notes",
  boxType: "input",
  type: "text",
  boxSize: 12,
  validatetype: "notes",
  multiline: true,
  multilineRows: 5,
  required: true,
};

export const AppointmentFormData: (edit: boolean) => FormObjType[] = (
  edit
) => {
  return [

    ...(edit
      ? [
        patientName,
        appointmentTypeName,
        // ControlledForm.FormData.PatientName(),
        // ControlledForm.FormData.AppointmentTypeName(),
        // ControlledForm.FormData.DeviceTypeName(),
      ]
      : [
        patientSearch,
        appointmentType,
        // ControlledForm.FormData.PatientSearch(),
        // ControlledForm.FormData.AppointmentType(),
        // ControlledForm.FormData.DeviceType(),
      ]),
    deviceTypeName,
    orgName,
    providerName,
    appointmentDateTime,
    timezoneData,
    appointmentNotes,
    // ControlledForm.FormData.OrgName(),
    // ControlledForm.FormData.ProviderName(),
    // ControlledForm.FormData.AppointmentDateTime(),
    // ControlledForm.FormData.TimezoneData({ dropArr: TimeZoneArr, boxSize: 6 }),
    // ControlledForm.FormData.AppointmentNotes(),
  ];
};
